import { StandardResponse } from '@/types/common';
import {
  CreateLearningPathPayload,
  LearningPath,
  PublishResponse,
  UpdateLearningPathPayload,
  UserLearningPathResponse,
} from '../types/learning-path';
import axiosInstance from './utils/axios';

const BASE_URL = '/agentos/learning-paths/';

const LearningPathService = {
  getLearningPaths: async (
    filters?: Record<string, any>
  ): Promise<StandardResponse<LearningPath>> => {
    const { data } = await axiosInstance.get(BASE_URL, { params: filters });
    return data;
  },

  getLearningPathById: async (id: number): Promise<LearningPath> => {
    const { data } = await axiosInstance.get(`${BASE_URL}${id}/`);
    return data;
  },

  createLearningPath: async (
    payload: CreateLearningPathPayload
  ): Promise<LearningPath> => {
    const { data } = await axiosInstance.post(BASE_URL, payload);
    return data;
  },

  updateLearningPath: async (
    id: number,
    payload: UpdateLearningPathPayload
  ): Promise<LearningPath> => {
    const { data } = await axiosInstance.patch(`${BASE_URL}${id}/`, payload);
    return data;
  },

  deleteLearningPath: async (
    id: number
  ): Promise<StandardResponse<LearningPath>> => {
    const { data } = await axiosInstance.delete(`${BASE_URL}${id}/`);
    return data;
  },

  publishLearningPath: async (id: number): Promise<PublishResponse> => {
    const { data } = await axiosInstance.post(`${BASE_URL}${id}/publish/`);
    return data;
  },

  getMyLearningPaths: async (filters?: {
    tag?: string;
    search?: string;
  }): Promise<UserLearningPathResponse> => {
    const { data } = await axiosInstance.get('/agentos/my-learning-paths/', {
      params: filters,
    });
    return data;
  },
};

export default LearningPathService;
